if (!customElements.get('yc-slideshow')) {
  class YcSlideshow extends HTMLElement {
    connectedCallback() {

    var root = this;
    if (!root) return;
    var slider = root.querySelector('slide-show');
    var audioOn = false;
    var btn = root.querySelector('.slideshow__audio-toggle');
    function getSlides() {
      return root.querySelectorAll('.slideshow__slide');
    }
    function getActiveSlide() {
      var s = root.querySelector('.slideshow__slide.is-selected');
      if (!s) s = root.querySelector('.slideshow__slide.is-initial-selected');
      return s;
    }
    function getVisibleProviderWrap(slide) {
      var wraps = slide.querySelectorAll('.slideshow__slide-video-bg');
      var found = null;
      wraps.forEach(function(w) {
        var cs = window.getComputedStyle(w);
        if (cs.display !== 'none' && !found) {
          found = w;
        }
      });
      return found || wraps[0] || null;
    }
    function hasVideo(slide) {
      return !!getVisibleProviderWrap(slide);
    }
    function ensureLoadedProviderWrap(providerWrap) {
      if (!providerWrap) return;
      var provider = providerWrap.getAttribute('data-provider');
      if (provider !== 'hosted') {
        var i = providerWrap.querySelector('iframe');
        if (i) {
          var dataSrc = i.getAttribute('data-src');
          var src = i.getAttribute('src');
          if (!src && dataSrc) {
            i.setAttribute('src', dataSrc);
            i.removeAttribute('data-src');
            i.classList.remove('lazyload');
          }
          var vid = providerWrap.getAttribute('data-video-id');
          var current = i.getAttribute('src') || '';
          if (current.indexOf('player.vimeo.com') !== -1 && audioOn) {
            if (current.indexOf('background=1') !== -1 || current.indexOf('muted=1') !== -1) {
              var newSrc = 'https://player.vimeo.com/video/' + vid + '?autoplay=1&loop=1&muted=0';
              i.setAttribute('src', newSrc);
            }
          }
        }
      }
    }
    function withIframeReady(iframe, fn) {
      if (!iframe) return;
      if (iframe.contentWindow) {
        fn(iframe.contentWindow);
        return;
      }
      var tries = 0;
      var timer = setInterval(function() {
        tries++;
        if (iframe.contentWindow) {
          clearInterval(timer);
          fn(iframe.contentWindow);
        } else if (tries > 30) {
          clearInterval(timer);
        }
      }, 100);
      iframe.addEventListener('load', function() {
        if (iframe.contentWindow) fn(iframe.contentWindow);
      });
    }
    function muteTarget(providerWrap, provider) {
      if (!providerWrap) return;
      if (provider === 'hosted') {
        var v = providerWrap.querySelector('video');
        if (v) v.muted = true;
      } else if (provider === 'youtube') {
        var i = providerWrap.querySelector('iframe');
        withIframeReady(i, function(win) {
          win.postMessage(JSON.stringify({event:'command',func:'mute',args:''}), '*');
        });
      } else {
        var i = providerWrap.querySelector('iframe');
        withIframeReady(i, function(win) {
          win.postMessage(JSON.stringify({method:'setVolume',value:0}), '*');
        });
      }
    }
    function unmuteTarget(providerWrap, provider) {
      if (!providerWrap) return;
      if (provider === 'hosted') {
        var v = providerWrap.querySelector('video');
        if (v) { v.muted = false; if (v.paused) { v.play().catch(function(){}); } }
      } else if (provider === 'youtube') {
        var i = providerWrap.querySelector('iframe');
        withIframeReady(i, function(win) {
          win.postMessage(JSON.stringify({event:'command',func:'unMute',args:''}), '*');
          win.postMessage(JSON.stringify({event:'command',func:'setVolume',args:[100]}), '*');
          if (audioOn) {
            win.postMessage(JSON.stringify({event:'command',func:'playVideo',args:''}), '*');
          }
        });
      } else {
        var i = providerWrap.querySelector('iframe');
        var vid = providerWrap.getAttribute('data-video-id');
        if (i) {
          var current = i.getAttribute('src') || i.getAttribute('data-src') || '';
          if (current.indexOf('player.vimeo.com') !== -1 && (current.indexOf('background=1') !== -1 || current.indexOf('muted=1') !== -1)) {
            var newSrc = 'https://player.vimeo.com/video/' + vid + '?autoplay=1&loop=1&muted=0&background=0';
            i.setAttribute('src', newSrc);
            i.removeAttribute('data-src');
            i.classList.remove('lazyload');
          }
        }
        withIframeReady(i, function(win) {
          win.postMessage(JSON.stringify({method:'setVolume',value:1}), '*');
          if (audioOn) {
            win.postMessage(JSON.stringify({method:'play'}), '*');
          }
        });
      }
    }
    function muteAll() {
      getSlides().forEach(function(slide) {
        var wrap = getVisibleProviderWrap(slide);
        if (!wrap) return;
        var provider = wrap.getAttribute('data-provider');
        muteTarget(wrap, provider);
      });
    }
    function applyForActive() {
      var active = getActiveSlide();
      if (btn) btn.style.display = (active && hasVideo(active)) ? '' : 'none';
      getSlides().forEach(function(slide) {
        var wrap = getVisibleProviderWrap(slide);
        if (!wrap) return;
        var provider = wrap.getAttribute('data-provider');
        ensureLoadedProviderWrap(wrap);
        if (slide === active) {
          if (audioOn) {
            unmuteTarget(wrap, provider);
          } else {
            muteTarget(wrap, provider);
          }
        } else {
          muteTarget(wrap, provider);
        }
      });
      if (btn) {
        btn.setAttribute('data-state', audioOn ? 'on' : 'off');
        btn.setAttribute('aria-pressed', audioOn ? 'true' : 'false');
      }
    }
    muteAll();
    applyForActive();
    setTimeout(applyForActive, 200);
    if (btn) {
      btn.addEventListener('click', function() {
        audioOn = btn.getAttribute('data-state') !== 'on';
        applyForActive();
        setTimeout(applyForActive, 200);
      });
    }
    var observer = new MutationObserver(function() { applyForActive(); });
    getSlides().forEach(function(slide) {
      observer.observe(slide, {attributes: true, attributeFilter: ['class']});
    });
    if (slider && slider.addEventListener) {
      var reapply = function() { applyForActive(); setTimeout(applyForActive, 200); };
      slider.addEventListener('select', reapply);
      slider.addEventListener('settle', reapply);
      slider.addEventListener('change', reapply);
    }
    document.addEventListener('lazyloaded', function(e) {
      if (root.contains(e.target)) {
        applyForActive();
        setTimeout(applyForActive, 100);
      }
    });
    var reapplyGlobal = function() { applyForActive(); setTimeout(applyForActive, 200); };
    window.addEventListener('resize', reapplyGlobal);
    window.addEventListener('orientationchange', reapplyGlobal);
    document.addEventListener('visibilitychange', function() {
      if (!document.hidden) reapplyGlobal();
    });
  
    }
  }
  customElements.define('yc-slideshow', YcSlideshow);
}
